var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          ref: "plxTable",
          staticStyle: { "margin-top": "10px" },
          attrs: {
            data: _vm.fileList,
            "max-height": "500",
            "show-overflow": "ellipsis",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "附件类型", align: "center", prop: "userName" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.docComments.split("-")[
                            scope.row.docComments.split("-").length - 1
                          ]
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "文件名称", prop: "documentName" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onDownload(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.documentName))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "文件描述", align: "center", prop: "docComments" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.docComments.split(
                            "-" +
                              scope.row.docComments.substring(
                                scope.row.docComments.lastIndexOf("-") + 1,
                                scope.row.docComments.length
                              )
                          )[0]
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "上传人", align: "center", prop: "userName" },
          }),
          _c("el-table-column", {
            attrs: { label: "上传时间", align: "center", prop: "createDate" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }